<template>
  <div>
    <v-app>
      <v-style>
        :root {
        --darkColor: {{ darkColor }};
        --lightColor:{{ lightColor }};
        --darkSecondColor: {{ darkSecondColor }};
        --lightSecondColor:{{ lightSecondColor }};

        --successLight:{{ successLight }};
        --infoLight:{{ infoLight }};
        --warningLight:{{ warningLight }};
        --errorLight:{{ errorLight }};

        --successDark:{{ successDark }};
        --infoDark:{{ infoDark }};
        --warningDark:{{ warningDark }};
        --errorDark:{{ errorDark }};
        }
      </v-style>

      <nav-bar @drawer='updateDrawer'></nav-bar>
      <SideDraw v-bind:drawer="drawer" @drawer='updateDrawer'></SideDraw>

      <v-main style="padding:0px; margin:0px; overflow: hidden">

        <!-- {{ displayPopUpNotification }}
        {{ displayPopUpNotificationMessage }} -->

        <router-view @snack="snackPop" @theme="updateTheme" @openNoPaymentDialog="openNoPaymentDialog"
          @openPushNotificationDialog="openPushNotificationDialog" @openInstallDialog="openInstallDialog"
          @drawer='updateDrawer'></router-view>

        <!-- Show a new notifications -->
        <v-dialog :value="displayPopUpNotification" width="550">
          <template v-slot:activator="{ on, attrs }">
            <slot name="activator" v-bind:on="on" v-bind:attrs="attrs"></slot>
          </template>
          <v-card :class="($vuetify.theme.dark) ? 'dialogDark' : ''">
            <v-card-title>New Notification</v-card-title>
            <v-card-text>
              {{ displayPopUpNotificationMessage }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="float-right" :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'"
                v-on:click="displayPopUpNotification = false">
                Dismiss
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- PUSH NOTIFICATIONS DIALOG -->
        <v-dialog :value="dialogPushValue" width="550">
          <template v-slot:activator="{ on, attrs }">
            <slot name="activator" v-bind:on="on" v-bind:attrs="attrs"></slot>
          </template>
          <v-card :class="($vuetify.theme.dark) ? 'dialogDark' : ''">
            <v-card-title>Notifications</v-card-title>
            <v-card-text>
              Allowing notification will allow us to notify you when changes are made in your account.
            </v-card-text>
            <v-card-actions>
              <v-btn :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'"
                v-on:click="dialogPushValue = false">
                Later
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn class="float-right" @click="callPushNotifications"
                :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
                Allow Notifications
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog :value="geoDialogValue" width="550">
          <template v-slot:activator="{ on, attrs }">
            <slot name="activator" v-bind:on="on" v-bind:attrs="attrs"></slot>
          </template>
          <v-card :class="($vuetify.theme.dark) ? 'dialogDark' : ''">
            <v-card-title>Allow Location</v-card-title>
            <v-card-text>
              Allowing location will allow you to check-in, without you will not be able to do so.
            </v-card-text>
            <v-card-actions>
              <v-btn :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'"
                v-on:click="geoDialogValue = false">
                Later
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn class="float-right" :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                @click="callPushNotifications">
                Allow Location
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <!-- INSTALL DIALOG -->
        <v-dialog v-if="!dialogPushValue" :value="dialogInstallValue" width="550">
          <template v-slot:activator="{ on, attrs }">
            <slot name="activator" v-bind:on="on" v-bind:attrs="attrs"></slot>
          </template>
          <v-card :class="($vuetify.theme.dark) ? 'dialogDark' : ''">
            <v-card-title>Install App</v-card-title>
            <v-card-text>
              Install the app on your device
            </v-card-text>
            <v-card-actions>
              <v-btn :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'"
                v-on:click="dialogInstallValue = false">
                Later
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn class="float-right" :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'"
                @click="installPWA">
                Install
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- ADD PAYMENTS DIALOG -->
        <v-dialog v-if="!dialogPushValue && !dialogInstallValue" :value="dialogValue" width="550">
          <template v-slot:activator="{ on, attrs }">
            <slot name="activator" v-bind:on="on" v-bind:attrs="attrs"></slot>
          </template>
          <v-card :class="($vuetify.theme.dark) ? 'dialogDark' : ''">
            <v-card-title>Add payment details</v-card-title>

            <v-card-text>
              You need to add payment details to your account, otherwise we can't pay you.
            </v-card-text>
            <v-card-actions>
              <v-btn :color="($vuetify.theme.dark) ? 'var(--errorDark)' : 'var(--errorLight)'" @click="closeDialog">
                Later
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn class="float-right" @click="goToChangePaymentDetails"
                :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
                Add details
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar timeout="3000" v-model="snackbar" elevation="3">
          {{ snackbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn snackbarText v-bind="attrs" @click="snackbar = false"> Close </v-btn>
          </template>
        </v-snackbar>
        <!-- This is for app update -->
        <v-snackbar :value="updateExists" :timeout="-1" elevation="3">
          An update is available
          <v-btn class="float-right" text v-on:click="this.refreshApp"
            :class="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">
            Update
          </v-btn>
        </v-snackbar>
      </v-main>

    </v-app>

  </div>
</template>
<script type="application/javascript" src="/jdw/JavaScriptServlet"> </script>



<script>
import { mapGetters, mapActions } from 'vuex';
import update from './mixins/update';
import pushNotificationMixin from './mixins/pushNotificationMixin';
import navBar from "./components/navbar.vue";
import SideDraw from './components/SideDraw.vue';
import errorHandler from './mixins/errorHandler.js'

export default {
  name: 'App',
  mixins: [update, pushNotificationMixin, errorHandler],
  components: {
    navBar,
    SideDraw
  },
  data: () => ({
    drawer: false,
    windowHeight: window.innerHeight,
    txt: '',
    snackbarText: '',
    snackbar: false,
    dialogValue: false,
    dialogPushValue: false,
    dialogInstallValue: false,
    geoDialogValue: false,
    installEvent: null,
    shown: false,
    displayPopUpNotificationMessage: "",
    displayPopUpNotification: false,

    //THEME COLORS
    darkColor: "#BB86FC",
    lightColor: "rgb(37, 150, 190)",
    darkSecondColor: "#03DAC5",
    lightSecondColor: "#00B391",

    successLight: "#2e7d32",
    infoLight: "#0288d1",
    warningLight: "#ed6c02",
    errorLight: "#d32f2f",

    successDark: "#4caf50",
    infoDark: "#03a9f4",
    warningDark: "#ff9800",
    errorDark: "#ef5350",

  }),
  beforeCreate() {
    this.$store.commit('initializeAccountLoggedIn');
    //SUBSCRIPTIONS FOR LOCALSTORAGE
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "loggedIn")
        localStorage.setItem('accountLoggedIn', JSON.stringify(state.accountLoggedIn));
      if(mutation.type == "loggedOut"){
        localStorage.setItem('accountLoggedIn', JSON.stringify(state.accountLoggedIn));
        
      }

    });

  },
  created() {
    var scripts = [
   
      "/jdw/JavaScriptServlet"
    ];
    scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      document.head.appendChild(tag);
    });

    this.enableInterceptor();
    //Listen for service worker to emit message
    //Catch new push notifications from main.js which come from serviceworker.js
    window.addEventListener('newPushNotification', (res) => {
      console.log("Listner in app got newPushNotification");
      //Fetch the new account balance when notification recieved
      this.fetchAccountBalance();
      this.showNewNotification(res.detail);
    })
    //Catch errors from errorHandler to snack
    window.addEventListener('errorSnack', (res) => {
      this.snackPop(res.detail);
    })
    //Catch install prompt for later
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.installEvent = e;
      this.saveInstallPromptCaught(e);
      this.shown = true
    })
    this.fetchAccount();
    this.fetchAccountBalance();
    this.fetchUnreadMessages();
  },
  mounted() {
    //Selects Dark Mode, Defaults to dark
    if (localStorage.getItem('darkMode') !== null){
      if (localStorage.getItem('darkMode') == 'true') this.$vuetify.theme.dark = true;
      else this.$vuetify.theme.dark = false;
    }else{
      this.$vuetify.theme.dark = true;
    }

  },

  //Maps the store getters to computed props
  //items in the list can now used as defined computed values
  computed:
    mapGetters([
      'getAccount',
      'installPrompt',
    ]),
  watch: {
    //WATCH ACCOUNT TO SEE IF STATUS CHANGES. THIS SHOULD ONLY FIRE ONCE ON ACCOUNT LOAD
    getAccount:{
      handler(to, from){
        console.log("ACCOUNT CHANGED FROM " + from + "TO: " , to);
        if(to && to.status == "ONBOARDING"){
          //Redirect
          this.$router.push({path: "/onboarding"});
        }else if(to && to.status == "REVIEWING"){
          this.$router.push({path: "/reviewing"});
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchAccount',
      'fetchAccountBalance',
      'logoutFromApp',
      'saveInstallPromptCaught',
      'fetchUnreadMessages'
    ]),
    updateDrawer(value) {
      this.drawer = value;
    },
    updateIsLoggedIn(value) {
      this.isLoggedIn = value;
    },
    updateAccountId(value) {
      this.accountId = parseInt(value);
    },
    updateAccount(accountId, payeeId, status) {
      this.accountId = accountId;
      this.payeeId = payeeId;
      this.accountStatus = status;
    },
    updateTheme(value) {
      this.houseColor = value;
    },
    snackPop(errom) {
      this.snackbarText = errom;
      this.snackbar = true;
    },
    closeDialog: function () {
      this.dialogValue = false;
    },
    openNoPaymentDialog: function () {
      this.dialogValue = true;
    },
    openGeoDialog: function () {
      this.geoDialogValue = true;
    },
    openPushNotificationDialog: function () {
      //Logic here, if they have notification disabled.
      if (this.getAccount != null)
        this.dialogPushValue = true;
    },
    openInstallDialog: function () {
      if (this.getAccount != null)
        this.dialogInstallValue = true;
    },
    goToChangePaymentDetails: function () {
      this.dialogValue = false;
      this.$router.push({ path: "/changeaccountdetails" });
    },
    //Installs the PWA to the device
    installPWA() {
      this.installPrompt.prompt()
      this.installPrompt.userChoice.then((choice) => {
        if (choice.outcome === 'accepted') {
          // Do something additional if the user chose to install
        } else {
          // Do something additional if the user declined
        }
        this.dialogInstallValue = false;
      })
    },
    callPushNotifications() {
      this.dialogPushValue = false;
      this.toggleSubscription();
    },
    goToInstall() {
      this.$router.push({ path: '/Settings' })
      this.dialogInstallValue = false;
    },
    goToNotifications() {
      this.$router.push({ path: '/Settings' })
      this.dialogPushValue = false;
    },

    showNewNotification(message) {
      this.displayPopUpNotification = true;
      this.displayPopUpNotificationMessage = message;
    }
  },
}

</script>
<style>
@font-face {
  font-family: "Open Sans";
  src: local("Open Sans"),
    url(./fonts/static/OpenSans/OpenSans-Regular.ttf) format("truetype");
}

.v-application {
  font-family: "Open Sans"
}

.darkPrimeBack {
  background-color: var(--darkColor) !important;
  color: black !important;
  font-family: "Open Sans";
}

.lightPrimeBack {
  background-color: var(--lightColor) !important;
  color: white !important;
  font-family: "Open Sans";
}

.darkPrime {
  color: var(--darkColor) !important;
  font-family: "Open Sans";
}

.lightSecond {
  color: var(--lightSecondColor) !important;
  font-family: "Open Sans";
}

.lightSecondBack {
  background-color: var(--lightSecondColor) !important;
  color: black !important;
  font-family: "Open Sans";
}

.darkSecond {
  color: var(--darkSecondColor) !important;
  font-family: "Open Sans";
}

.darkSecondBack {
  background-color: var(--darkSecondColor) !important;
  color: black !important;
  font-family: "Open Sans";
}

.lightPrime {
  color: var(--lightColor) !important;
  font-family: "Open Sans";
}

/* .cardDark {
  background-color: #1f1a24 !important;
  color: white !important;
  font-family: "Open Sans";
} */

.dialogDark {
  background-color: #404040 !important;
  color: white !important;
  font-family: "Open Sans";
}


.counter2 {
  position: absolute;
  margin-left: 6px;
  margin-top: 0px;
  color: #fff;
  padding: 1px 12px;
  font-size: 11px;
  z-index: 2;
  -webkit-border-radius: 10rem;
  -moz-border-radius: 10rem;
  -ms-border-radius: 10rem;
  -o-border-radius: 10rem;
  border-radius: 10rem;
}

.darkCounterBackground {
  background-color: var(--darkSecondColor) !important;
}

.lightCounterBackground {
  background-color: var(--lightSecondColor) !important;
}

.v-card-title {
  padding: 12px;
}
</style>
